function oneTrustChangeLanguage() {
}
oneTrustChangeLanguage.prototype.changeCookiesLanguage = function changeCookiesLanguage(lang) {
    try {
        OneTrust.changeLanguage(lang)

    } catch (e) {
    }
};
var oneTrustModule = new oneTrustChangeLanguage()
export { oneTrustModule }